export default "__VITE_ASSET__BP2gXls5__"